import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import Documentcategories from './documentcategories/Documentcategories';
import Postingtypes from './postingtypes/Postingtypes';
import Colors from './colors/Colors';
import Formats from './formats/Formats';

export default function Designer({
  colors,
  documentcategories,
  documenttypes,
  formats,
  postingtypes,
  variables,
  onSetColors,
  onSetDocumentcategories,
  onSetDocumenttypes,
  onSetFormats,
  onSetPostingtypes,
}) {
  return (
    <Routes>
      <Route
        path="documentcategories/*"
        element={(
          <Documentcategories
            colors={colors}
            documentcategories={documentcategories}
            documenttypes={documenttypes}
            formats={formats}
            variables={variables}
            onSetDocumentcategories={onSetDocumentcategories}
            onSetDocumenttypes={onSetDocumenttypes}
          />
        )}
      />
      <Route
        path="postingtypes/*"
        element={(
          <Postingtypes
            colors={colors}
            postingtypes={postingtypes}
            variables={variables}
            onSetPostingtypes={onSetPostingtypes}
          />
        )}
      />
      <Route
        exact
        path="colors/*"
        element={(
          <Colors
            colors={colors}
            onSetColors={onSetColors}
          />
        )}
      />
      <Route
        exact
        path="formats/*"
        element={(
          <Formats
            formats={formats}
            onSetFormats={onSetFormats}
          />
        )}
      />
    </Routes>
  );
}

Designer.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape({})),
  documentcategories: PropTypes.arrayOf(PropTypes.shape({})),
  documenttypes: PropTypes.arrayOf(PropTypes.shape({})),
  formats: PropTypes.arrayOf(PropTypes.shape({})),
  postingtypes: PropTypes.arrayOf(PropTypes.shape({})),
  variables: PropTypes.arrayOf(PropTypes.shape({})),
  onSetColors: PropTypes.func.isRequired,
  onSetDocumentcategories: PropTypes.func.isRequired,
  onSetDocumenttypes: PropTypes.func.isRequired,
  onSetFormats: PropTypes.func.isRequired,
  onSetPostingtypes: PropTypes.func.isRequired,
};

Designer.defaultProps = {
  colors: undefined,
  documentcategories: undefined,
  documenttypes: undefined,
  formats: undefined,
  postingtypes: undefined,
  variables: undefined,
};
